import { render, staticRenderFns } from "./indonesian_leadership_classC.vue?vue&type=template&id=0b7b2a4b&scoped=true"
import script from "./indonesian_leadership_classC.vue?vue&type=script&lang=js"
export * from "./indonesian_leadership_classC.vue?vue&type=script&lang=js"
import style0 from "./indonesian_leadership_classC.vue?vue&type=style&index=0&id=0b7b2a4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7b2a4b",
  null
  
)

export default component.exports